import Consent from './plugins/consent.js'
import Overlay from './plugins/overlay.js'

export default {
  Consent,
  Overlay
}
